export default class Parse {
  static make(data: any): number {
    if (!data) return 0;

    const result = parseInt(data.replace(/[^0-9]/ig, ''), 10);
    if (!result) return 0;
    return result;
  }
}
